<template>
  <div class="product__item product__item-d">
    <div class="product__thumb fix">
      <div class="product-image w-img">
        <router-link :to="`/shop-details/${product.id}`">
          <img :src="product.image" alt="product" />
        </router-link>
      </div>

      <div class="product-image__overlay-top-left ">
        <div v-if="product.quantity	== 0" class="label label--hot" data-js-product-label-hot="">
          Sold Out
        </div>
        <div v-if="product.discount_percentage" class="label label--sale" >-{{ product.discount_percentage }}%</div>
      </div>



      <div class="product-action">
        <a href="#" class="icon-box icon-box-1 " data-bs-toggle="modal"
          @click.prevent="handleOpenModal(`product-modal-${product.id}`, product)">
          <!-- :data-bs-target="`#${utilityStore.modalId}`"-->
          <i class="fas fa-eye"></i>
          <i class="fas fa-eye"></i>
        </a>

        <a href="#" class="icon-box icon-box-1 active">
          <!--  @click.prevent="wishlistStore.add_wishlist_product(product)" :class="`icon-box icon-box-1 ${isItemInWishlist(product) ? 'active' : ''}`"-->

          <i class="fas fa-heart"></i>
          <i class="fas fa-heart"></i>
        </a>

        <!--<a
            href="#"
            class="icon-box icon-box-1 active"
          >
           @click.prevent="compareStore.add_compare_product(product)"
            :class="`icon-box icon-box-1 ${isItemInCompare(product) ? 'active' : ''}`"
            
            <i class="fas fa-layer-group"></i>
            <i class="fas fa-layer-group"></i>
          </a> -->
      </div>
    </div>
    <div class="product__content-3">
      <h6><router-link :to="`/product-details/${product.id}`">{{ product.title }}</router-link></h6>
      <div v-if="product.discount_percentage > 0" class="product-stock mb-15">
        <h5 class="left">
          <span>LKR {{ product.price }}</span>
          <br />
          <del> LKR {{ calculateOriginalPrice(product.price, product.discount_percentage).toFixed(2) }}</del>
        </h5>
      </div>


      <div v-else class="product-stock mb-15">
        <h5><span>LKR {{ product.price }}</span></h5>
      </div>
      <!--
        <div class="rating mb-5">
          <ul>
            <li><a href="#"><i class="fas fa-star"></i></a></li>
            <li><a href="#"><i class="fas fa-star"></i></a></li>
            <li><a href="#"><i class="fas fa-star"></i></a></li>
            <li><a href="#"><i class="fas fa-star"></i></a></li>
            <li><a href="#"><i class="fas fa-star"></i></a></li>
          </ul>
          <span>(1 review)</span>
        </div>
        <div class="price mb-10">
          <span>Sold:{{ product.sold }}/{{ product.quantity }}</span>
        </div>

      -->
    </div>
    <div class="product__add-cart-s text-center">
      <button  v-if="!isItemInCart(product) || product.quantity	== 0" @click="cartStore.addCartProduct(product)" type="button"
        class="cart-btn d-flex mb-10 align-items-center justify-content-center w-100">
        Add to Cart
      </button>

      <router-link to="/cart" v-if="isItemInCart(product)"
        class="cart-btn d-flex mb-10 align-items-center justify-content-center w-100">
        View Cart
      </router-link>
      <!--
      <button type="button" class="wc-checkout d-flex align-items-center justify-content-center w-100"
        data-bs-toggle="modal">
         @click.prevent="handleOpenModal(`product-modal-${product.id}`, product)" :data-bs-target="`#${utilityStore.modalId}`" 
        Quick View
      </button>-->
    </div>
  </div>
</template>

<script>
import { useCartStore } from "@/stores/useCartStore"
import { calculateOriginalPrice } from "@/utils/utils"
//import { useWishlistStore } from "@/stores/wishlistStore";
//import { useUtilsStore } from "@/stores/utilsStore";
//import { useCompareStore } from "@/stores/compareStore";

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cartStore: useCartStore(),
      calculateOriginalPrice
      //wishlistStore: useWishlistStore(),
      //utilityStore: useUtilsStore(),
      //compareStore: useCompareStore(),
    }
  },
  methods: {
    isItemInWishlist(product) {
      return this.wishlistStore.wishlists.some((prd) => prd.id === product.id)
    },

    isItemInCart(product) {
      // Return true if the product exists in the cart
      return this.cartStore.cart_products.some((prd) => prd.id === product.id)
    },

    isItemInCompare(product) {
      return this.compareStore.compare_items.some((prd) => prd.id === product.id)
    },
    handleOpenModal(modalId, product) {
      this.utilityStore.handleOpenModal(modalId, product)
    },
  },
}
</script>
<style scoped>
/* Add any necessary custom styles here */
.product-stock h5 del {
  color: #cc1414;
}

.product-stock h5 del {
  margin-left: 10px;
  font-size: 12px;
}

.left {
  float: left
}

.right {
  float: right
}



.label--hot {
  background-color: #cc1414;
  width: 68px !important;
}

.product-image__overlay-top-left {
  align-items: flex-start;
  flex-direction: column;
  display: flex;
  position: absolute;
  top: 3px;
  left: 0px;
}

.product-image__overlay-top-left .label {
  display: flex;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  height: 20px;
  padding: 5px;
  margin-bottom: 5px;
  align-items: center;
  position: relative;
  text-transform: uppercase;
  width: 50px;
  border-radius: 2px;
  justify-content: center;
}
.label--sale {
  background-color: #5aab19;
}
</style>